module.exports = __webpack_public_path__ + "static/media/10_evenement.fa791340.jpg";